import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Clock, MapPin, ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { locations, clinicInteriorImage } from '../mock';

const LocationsPage = () => {
  return (
    <div className="App bg-white">
      <Header />
      <PageHero
        eyebrow="Find us"
        title="Windsor physiotherapy"
        italic="clinic."
        description="Visit Uptown Physiotherapy Clinic on Tecumseh Road East for dedicated parking, modern rehab equipment, and a warm reception team ready to help you get started."
        image={clinicInteriorImage}
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Locations' }]}
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-[1240px] mx-auto px-6 space-y-8">
          {locations.map((l, idx) => (
            <div key={l.slug} className={`grid lg:grid-cols-2 gap-10 items-center ${idx % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''}`}>
              <Link to={`/locations/${l.slug}`} className="rounded-[24px] overflow-hidden aspect-[5/4] block bg-neutral-100">
                <img src={l.image} alt={l.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </Link>
              <div>
                <span className="text-[12px] font-semibold tracking-[0.2em] text-[#CA0028] uppercase">Windsor Clinic</span>
                <h3 className="mt-3 text-[34px] lg:text-[42px] font-bold tracking-tight text-neutral-900">{l.name}</h3>
                <div className="mt-6 space-y-3 text-[15px] text-neutral-700">
                  <p className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-neutral-500" /> {l.address}</p>
                  <p className="flex items-center gap-3"><Phone size={16} className="text-neutral-500" /> {l.phone}</p>
                  <p className="flex items-center gap-3"><Mail size={16} className="text-neutral-500" /> {l.email}</p>
                  <p className="flex items-center gap-3"><Clock size={16} className="text-neutral-500" /> {l.hours}</p>
                </div>
                <div className="mt-6 flex flex-wrap gap-2">
                  {l.features.map((f) => (
                    <span key={f} className="text-[12px] px-3 py-1 rounded-full bg-neutral-100 text-neutral-800">{f}</span>
                  ))}
                </div>
                <Link to={`/locations/${l.slug}`} className="mt-8 inline-flex items-center gap-2 bg-[#CA0028] hover:bg-[#A80021] text-white text-[14px] font-medium pl-6 pr-2 py-2 rounded-full transition-colors">
                  Clinic Details
                  <span className="w-8 h-8 grid place-items-center rounded-full bg-white/10">
                    <ArrowRight size={14} />
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LocationsPage;
